(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var cartForm = document.querySelector('form.cart');
    if (!cartForm) return;

    cartForm.querySelectorAll('input[name^="updates["]').forEach(function (input) {
      input.addEventListener('change', function () {
        cartForm.submit();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hello-world"]) return;
  try {
    
    // Propably use on load when manipulating images
    window.onload = function () {};

    document.addEventListener('DOMContentLoaded', (event) => {
        gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

        ScrollSmoother.create({
            smooth: 2,
            effects: true,
        });

        const tl = gsap.timeline();
        const anim_book = gsap.timeline();

        anim_book.from('.anim-book', {
            opacity: 0,
            duration: 1,
        });
        anim_book.from('.anim-book-page', {
            opacity: 0,
            xPercent: -30,
            rotation: -20,
            duration: 0.8,
        });

        gsap.to('.anim-book-page', {
            x: -200,
            scrollTrigger: {
                trigger: '.anim-book-page',
                start: 'top top',
                end: 'bottom top',
                scrub: 1,
            },
        });

        gsap.to('.animation-video', {
            yPercent: -30,
            scrollTrigger: {
                trigger: '.animation-video',
                start: 'center center',
                end: 'bottom top',
                scrub: 1,
            },
        });

        gsap.from('.img-anim', {
            scale: 0.5,
            scrollTrigger: {
                trigger: '.img-anim',
                start: 'top bottom',
                end: 'top center',
                scrub: 1,
            },
        });

        gsap.from('.desc-anim', {
            opacity: 0,
            xPercent: 100,
            scrollTrigger: {
                trigger: '.desc-anim',
                start: 'top bottom',
                end: 'top center',
                scrub: 1,
            },
        });

        gsap.from('.img-anim2', {
            scale: 0.5,
            scrollTrigger: {
                trigger: '.img-anim2',
                start: 'top bottom',
                end: 'top center',
                scrub: 1,
            },
        });

        gsap.from('.desc-anim2', {
            opacity: 0,
            xPercent: -100,
            scrollTrigger: {
                trigger: '.desc-anim2',
                start: 'top bottom',
                end: 'top center',
                scrub: 1,
            },
        });

        tl.from('.journal', { opacity: 0, duration: 1 });
        tl.from('.journal-page', { x: -200, rotation: -20, opacity: 0, duration: 1 });

        gsap.to('.journal-page', {
            xPercent: -30,
            scrollTrigger: {
                trigger: '.home-intro',
                start: 'top top',
                end: 'bottom top',
                scrub: 1,
            },
        });

        const StarEyesClosed = document.querySelectorAll('.star-eyes-open');
        const BuyNowButton = document.querySelectorAll('.buy-now-button');
        const DocHappy = document.querySelectorAll('.doc-happy-play');

        const BuyButton = document.querySelectorAll('.buy-button');
        const BuyButton2 = document.querySelectorAll('.buy-button2');

        StarEyesClosed.forEach((star) => CreateAnimation(star));
        BuyNowButton.forEach((element) => CreateSecondAnimation(element));
        BuyButton.forEach((element) => CreateThirdAnimation(element));
        BuyButton2.forEach((element) => CreateThirdAnimation2(element));
        DocHappy.forEach((element) => CreateDocHappy(element));

        function CreateDocHappy(element) {
            const DocHappyAnim = gsap.timeline({
                paused: true,
                reversed: true,
            });

            DocHappyAnim.to('.doc-happy', {
                keyframes: {
                    rotation: [10, -10, 10, -10, 0],
                },
                duration: 0.6,
            });
            element.addEventListener('mouseenter', () => {
                DocHappyAnim.reversed() ? DocHappyAnim.play() : DocHappyAnim.reverse();
            });

            element.addEventListener('mouseleave', () => {
                DocHappyAnim.reversed() ? DocHappyAnim.play() : DocHappyAnim.reverse();
            });
        }

        function CreateAnimation(element) {
            const StarEyesOpenAnimation = gsap.timeline({
                paused: true,
                reversed: true,
            });

            StarEyesOpenAnimation.to('.star-eyes-open', {
                opacity: 1,
                duration: 0.5,
            });

            element.addEventListener('mouseenter', () => {
                StarEyesOpenAnimation.reversed() ? StarEyesOpenAnimation.play() : StarEyesOpenAnimation.reverse();
            });

            element.addEventListener('mouseleave', () => {
                StarEyesOpenAnimation.reversed() ? StarEyesOpenAnimation.play() : StarEyesOpenAnimation.reverse();
            });
        }

        function CreateSecondAnimation(element) {
            const StarEyesOpenAnimation = gsap.timeline({
                paused: true,
                reversed: true,
            });

            StarEyesOpenAnimation.to('.star-eyes-closed', {
                opacity: 0,
                duration: 0,
            });
            StarEyesOpenAnimation.to('.star-eyes-open', {
                opacity: 1,
                duration: 0,
            });

            StarEyesOpenAnimation.to('.star-eyes-open', {
                yPercent: -20,
                rotation: -20,
                duration: 0.2,
            });

            element.addEventListener('mouseenter', () => {
                StarEyesOpenAnimation.reversed() ? StarEyesOpenAnimation.play() : StarEyesOpenAnimation.reverse();
            });

            element.addEventListener('mouseleave', () => {
                StarEyesOpenAnimation.reversed() ? StarEyesOpenAnimation.play() : StarEyesOpenAnimation.reverse();
            });
        }

        function CreateThirdAnimation(element) {
            const EmmyAnimation = gsap.timeline({
                paused: true,
                reversed: true,
            });

            EmmyAnimation.to('.emmy-happy', {
                opacity: 1,
                yPercent: -80,
            });

            element.addEventListener('mouseenter', () => {
                EmmyAnimation.reversed() ? EmmyAnimation.play() : EmmyAnimation.reverse();
            });

            element.addEventListener('mouseleave', () => {
                EmmyAnimation.reversed() ? EmmyAnimation.play() : EmmyAnimation.reverse();
            });
        }
        function CreateThirdAnimation2(element) {
            const EmmyAnimation = gsap.timeline({
                paused: true,
                reversed: true,
            });

            EmmyAnimation.to('.emmy-happy2', {
                opacity: 1,
                yPercent: -80,
            });

            element.addEventListener('mouseenter', () => {
                EmmyAnimation.reversed() ? EmmyAnimation.play() : EmmyAnimation.reverse();
            });

            element.addEventListener('mouseleave', () => {
                EmmyAnimation.reversed() ? EmmyAnimation.play() : EmmyAnimation.reverse();
            });
        }
    });

  } catch(e) { console.error(e); }
})();
})();
